module.exports = __webpack_public_path__ + "static/media/image-13.683f7374.jpg";